<template>
  <div class="container">
    <img src="../../common/images/111.png" width="100%" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.container{
  padding-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/dashboard/dashboard.vue